var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success_container"},[_c('img',{attrs:{"src":require("@/static/images/my_index/ok.png"),"alt":""}}),_c('p',{staticClass:"result"},[_vm._v("感谢您耐心认真的评价，请静待结果")])])
}]

export { render, staticRenderFns }